export const pokemonPortfolio = [
  {
    img: require("./assets/projects/apps/pokedex/pokemon.gif"),
    // appLink: "https://j0nathanbell.github.io/pokemon/",
    link: "https://github.com/J0nathanbell/pokemon",
    link2: "https://j0nathanbell.github.io/pokemon/",
    paragraph: "A fun Pokedex app made with Vanilla JS",
  },
];
export const ipsoPortfolio = [
  {
    img: require("./assets/projects/apps/rejectionClose/python.gif"),
    // appLink: "https://github.com/J0nathanbell/large_screen_rejection_close",
    link: "https://github.com/J0nathanbell/large_screen_rejection_close",
    paragraph:
      "A mouse automation app for entering form data and sending emails",
  },
];
export const worksData = [
  {
    index: "1",
    icon: require("./assets/myPicture/lewagon.png"),
    title: "Experience",
    description: `Le wagon coding bootcamp London A 12 week intensive fullstack development bootcamp learning the fundamentals of MVC app architecture and development, utalising Ruby and the Rails framework, alongside HTML, SASSY/CSS and Javascript`,
    img: require("./assets/myPicture/bootcamp.webp"),
    img2: require("./assets/myPicture/lewagoncrew1.jpg"),
    link: "https://www.youtube.com/watch?v=jR9xcC7LZD4&t=1s",
  },
  {
    index: "2",
    title: "About me",
    description:
      "I recently converted an old laptop into a desktop, Installed linux on it for something to do. I enjoy fixing and repairing hardware. I spend my leisure time skateboarding and playing tennis! 🤘",
    img: require("./assets/projects/hardware/linuxComputer/images/merged.JPG"),
    img2: require("./assets/myPicture/skating2.gif"),
  },
];
